import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";

interface ReportFiltersProps<T extends object> {
    filters: T;
    setFilters: React.Dispatch<React.SetStateAction<T>>;
    fields: FilterField<T>[];
}

interface FilterField<T> {
    key: keyof T;
    label: string;
    type?: "text" | "select";
    options?: { value: string; label: string }[];
}

export const ReportCustomFilters = <T extends object>({ filters, setFilters, fields }: ReportFiltersProps<T>) => {
    return (
        <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: "16px" }}>
            {fields.map(field => {
                if (field.type === "select" && field.options) {
                    return (
                        <FormControl key={String(field.key)} variant="outlined" size="small" style={{ minWidth: 170 }}>
                            <InputLabel style={{ color: "#fff" }}>{field.label}</InputLabel>
                            <Select
                                value={filters[field.key] as string}
                                onChange={e =>
                                    setFilters(prev => ({ ...prev, [field.key]: e.target.value }))
                                }
                                label={field.label}
                                style={{ color: "#fff" }}
                            >
                                {field.options.map(opt => (
                                    <MenuItem key={opt.value} value={opt.value} style={{ color: "#fff" }}>
                                        {opt.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    );
                }

                return (
                    <TextField
                        key={String(field.key)}
                        variant="outlined"
                        size="small"
                        label={field.label}
                        value={filters[field.key] as string}
                        onChange={e =>
                            setFilters(prev => ({ ...prev, [field.key]: e.target.value }))
                        }
                        style={{ minWidth: 200 }}
                        InputProps={{ style: { color: "#fff" } }}
                        InputLabelProps={{ style: { color: "#fff" } }}
                    />
                );
            })}
        </Box>
    );
};
